import React from 'react';
import styled from 'styled-components';
import { sendEvent } from '../../../js/utils/gtm';

const StyledTeleporterWrapper = styled.div`
  button {
    width: 280px;
    height: 50px; 
    margin-top: 1rem;
    padding: 14px 32px; 
    border-radius: 10px;
    border: 2px solid #FF7000;
    background: #FF7000;
    color: white;
    font-size: 18px;
    font-weight: 500;
    font-family: 'Poppins', sans-serif;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    transition: all 0.3s ease-in-out;
    
    &:hover {
      background: #e26300;
      transform: translateY(-2px);
    }
    
    &:active {
      background: #cc5c00;
      transform: translateY(0);
    }
  }
`;

const Wrapper = styled.div`
&& {
  margin: auto;
  margin-top: 2rem;
  max-width: 70rem;
  display: flex;
  @media (max-width: 768px) {
    display: block;
    margin: 1rem;
  }

    font-size: var(--text-font-size);
    font-family: var(--font-family);
    position: relative;
    z-index: 1;

    p {
      font-size: var(--text-font-size);
    }

    a {
      color: var(--link-color);
      margin: 1rem 0;
    }

    h1 {
      letter-spacing: var(--has-letter-spacing);
    }

    h2, h2.span {
      font-family: var(--font-family);
      font-size: var(-h2-font-size);
      font-weight: var(--has-font-weight);
      letter-spacing: var(--has-letter-spacing);
    }
  }
`;

const Image = styled.img`
  margin: auto;
  width: 30rem;
  height: 30rem;
  @media (max-width: 768px) {
    display: block;
    margin: 1rem;
    width: 20rem;
    height: 20rem;
  }
`;

const HtmlBlock = styled.div`
  font-family: 'Poppins', sans-serif;
  background-color: #fff;
`;

const ABTestAboveFold = () => {
  const handleClick = () => {
    sendEvent({
      event: 'click_next',
    });
    window.location.href = '/hae-lainaa/';
  };

  return (
    <Wrapper>
      <div>
        <HtmlBlock dangerouslySetInnerHTML={{
          __html: `
          <div style="display: inline-block;">
            <h2 style="color: #1e1e1e; font-size: 24px; font-weight: 600;">
              <span style="font-size: 24pt; color: #432400;">Täytä lainahakemus - Saat lainapäätöksen heti</span>
            </h2>
            <div>
              <span style="color: #432400; margin-bottom: 5px;">Hae lainaa jopa 70 000 euroa ilman vakuuksia tai takaajia!</span>
            </div>
          </div>
        `,
        }}
        />

        <StyledTeleporterWrapper>
          <button type="button" onClick={handleClick}>
            Hae lainaa
          </button>
        </StyledTeleporterWrapper>

        <HtmlBlock dangerouslySetInnerHTML={{
          __html: `
          <div style="max-width: 500px; width: 100%; display: flex; flex-direction: column; justify-content: center; align-items: center; gap: 5px;">
            <div>
              <p style="color: #432400; font-size: 20px; font-weight: 600; line-height: 23px; margin: 1.5rem 0;">Vain muutaman näppäimen painalluksen päässä</p>
              <div style="display: flex; gap: 1rem; align-items: center; margin-bottom: 15px;">
                <div style="width: 57px; height: 57px; padding: 5px; background: #FFDBBF; border-radius: 50%; display: flex; justify-content: center; align-items: center;">
                  <img src="https://fi-omalaina-production-cms-uploadbucket-hnf2k3pbeict.s3.amazonaws.com/uploads/2025/04/payments.svg" alt="" width="35" height="35" />
                </div>
                <div>
                  <h3 style="color: #432400; font-size: 20px; font-weight: 600; line-height: 23px;">Lainapäätös heti!</h3>
                  <p style="color: #6f6f6f; font-size: 16px; line-height: 19px; max-width: 20rem; margin: 0;">Rahat maksetaan nopeimmillaan jo samana päivänä!</p>
                </div>
              </div>

              <div style="display: flex; gap: 1rem; align-items: center; margin-bottom: 15px;">
                <div style="width: 57px; height: 57px; padding: 5px; background: #FFDBBF; border-radius: 50%; display: flex; justify-content: center; align-items: center;">
                  <img src="https://fi-omalaina-production-cms-uploadbucket-hnf2k3pbeict.s3.amazonaws.com/uploads/2025/04/handshake.svg" alt="" width="37" height="38" />
                </div>
                <div>
                  <h3 style="color: #432400; font-size: 20px; font-weight:600; line-height: 23px;">Useita lainatarjouksia</h3>
                  <p style="color: #6f6f6f; font-size: 16px; line-height: 19px; max-width: 20rem; margin: 0;">Vertaile useita pankkeja ja luotonantajia yhdellä hakemuksella.</p>
                </div>
              </div>

              <div style="display: flex; gap: 1rem; align-items: center; margin-bottom: 15px;">
                <div style="width: 57px; height: 57px; padding: 5px; background: #FFDBBF; border-radius: 50%; display: flex; justify-content: center; align-items: center;">
                  <img src="https://fi-omalaina-production-cms-uploadbucket-hnf2k3pbeict.s3.amazonaws.com/uploads/2025/04/contract.svg" alt="" width="36" height="36" />
                </div>
                <div>
                  <h3 style="color: #432400; font-size: 20px; font-weight: 600; line-height: 23px;">Omalaina.fi on 100 %</h3>
                  <p style="color: #6f6f6f; font-size: 16px; line-height: 19px; max-width: 20rem; margin: 0;">Suomalainen turvallinen palvelu. Yli 300 000 asiakasta Suomessa.</p>
                </div>
              </div>
            </div>
          </div>
        `,
        }}
        />
      </div>

      <Image
        src="https://fi-omalaina-production-cms-uploadbucket-hnf2k3pbeict.s3.amazonaws.com/uploads/2025/03/Omalainaheroillu.png"
        alt="Iloinen mies ja nainen katsovat tablet-tietokonetta"
      />
    </Wrapper>
  );
};

export default ABTestAboveFold;
